import React from "react";
import { Zap, LayoutGrid, BookOpenText } from "lucide-react";

// Sprint 8.B — Mode-Switcher Quick/Insight/Detail im Cockpit-Header.
// Nur für Pro-User sichtbar. Free sieht stets Insight-Layout.

const MODES = [
  { key: "quick",   label: "Quick",   Icon: Zap },
  { key: "insight", label: "Insight", Icon: LayoutGrid },
  { key: "detail",  label: "Detail",  Icon: BookOpenText },
];

export default function ModeSwitcher({ mode, onChange }) {
  return (
    <div
      data-testid="mode-switcher"
      role="tablist"
      aria-label="Ansicht"
      className="inline-flex rounded-xl border border-slate-200 bg-white p-0.5 shadow-sm"
    >
      {MODES.map(({ key, label, Icon }) => {
        const active = mode === key;
        return (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(key)}
            data-testid={`mode-switcher-${key}`}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold transition-colors ${
              active
                ? "bg-[#4563BB] text-white shadow-sm"
                : "text-slate-600 hover:bg-slate-100"
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
